import { useLanguage } from "@/i18n/LanguageContext";
import Reveal from "@/components/Reveal";

export default function Process() {
  const { t } = useLanguage();
  return (
    <section id="process" data-testid="process-section" className="bg-white py-24 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <Reveal className="md:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-700 mb-4">{t.process.overline}</p>
            <h2 className="font-outfit text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-slate-950">
              {t.process.title}
            </h2>
            <p className="mt-6 text-base text-slate-600 leading-relaxed">{t.process.desc}</p>
          </Reveal>
          <div className="md:col-span-8">
            <div className="border-s border-slate-200">
              {t.process.steps.map((s, i) => (
                <Reveal key={s.n} delay={i * 0.08}>
                  <div data-testid={`process-step-${i}`} className="relative ps-10 pb-14 last:pb-0">
                    <span className="absolute -start-[5px] top-1.5 w-[9px] h-[9px] bg-brand-600" />
                    <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                      <span className="font-serif-display text-3xl text-slate-300">{s.n}</span>
                      <h3 className="font-outfit text-xl font-medium text-slate-950">{s.title}</h3>
                      <span className="text-xs uppercase tracking-widest text-brand-700">{s.time}</span>
                    </div>
                    <p className="mt-3 text-sm text-slate-600 leading-relaxed max-w-xl">{s.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
